/* PRIME DIGITAL GOODS — global.js */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ---- Header shadow on scroll ---- */
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---- Mobile drawer ---- */
    var drawer = document.querySelector('[data-drawer]');
    var overlay = document.querySelector('[data-overlay]');
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = document.querySelectorAll('[data-drawer-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');
      drawer.setAttribute('aria-hidden', 'false');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      drawer.setAttribute('aria-hidden', 'true');
    }
    openers.forEach(function (b) { b.addEventListener('click', openDrawer); });
    closers.forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    /* ---- FAQ accordion ---- */
    var faqItems = document.querySelectorAll('[data-faq-item]');
    faqItems.forEach(function (item) {
      var btn = item.querySelector('[data-faq-q]');
      var ans = item.querySelector('[data-faq-a]');
      if (!btn || !ans) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // optional: close siblings within same accordion
        var parent = item.parentElement;
        if (parent) {
          parent.querySelectorAll('[data-faq-item].is-open').forEach(function (other) {
            if (other !== item) {
              other.classList.remove('is-open');
              var oa = other.querySelector('[data-faq-a]');
              var ob = other.querySelector('[data-faq-q]');
              if (oa) oa.style.maxHeight = null;
              if (ob) ob.setAttribute('aria-expanded', 'false');
            }
          });
        }
        if (isOpen) {
          item.classList.remove('is-open');
          ans.style.maxHeight = null;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          ans.style.maxHeight = ans.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---- Smooth scroll for in-page anchors ---- */
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
          closeDrawer();
        }
      });
    });

    /* ---- Scroll reveal ---- */
    var reveals = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---- Product thumbnail swap ---- */
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = document.querySelector('[data-product-main-img]');
        if (main) main.src = thumb.getAttribute('data-full') || thumb.src;
      });
    });

  });
})();
